module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wrapper navbar-mini"
    }
  }, [_vm._t("side-menu"), _vm._v(" "), _c('div', {
    staticClass: "gray-bg",
    attrs: {
      "id": "page-wrapper"
    }
  }, [_vm._t("header"), _vm._v(" "), (_vm.action && _vm.subject) ? _c('can', {
    attrs: {
      "action": _vm.action,
      "subject": _vm.subject,
      "is-page": true
    }
  }, [_c('router-view')], 1) : _c('div', [_c('router-view')], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "40px"
    }
  }), _vm._v(" "), _vm._t("footer")], 2), _vm._v(" "), _vm._t("toast"), _vm._v(" "), _vm._t("alerts")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-882d399a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/app/MainLayout.vue
// module id = 3364
// module chunks = 3